export function rgbaToHex(rgba: string, withAlpha = false): string {
  if (!rgba) {
    return '';
  }

  const match = rgba.match(/^rgba\((\d+),\s*(\d+),\s*(\d+),\s*(\d*(?:\.\d+)?(?:\.\d+)?)\)$/);
  if (!match) {
    console.error('Invalid rgba color', rgba);
    return rgba;
  }

  const r = parseInt(match[1], 10);
  const g = parseInt(match[2], 10);
  const b = parseInt(match[3], 10);
  const a = Math.round(parseFloat(match[4]) * 255);

  const hexR = r.toString(16).padStart(2, '0');
  const hexG = g.toString(16).padStart(2, '0');
  const hexB = b.toString(16).padStart(2, '0');
  const hexA = a.toString(16).padStart(2, '0');

  if (withAlpha) {
    return `#${hexR}${hexG}${hexB}${hexA}`;
  }

  return `#${hexR}${hexG}${hexB}`;
}
